import { Mail, MessageCircle, Phone } from "lucide-react";
import { CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_TEL, whatsappUrl } from "@/constants/site";
import { usePartner } from "@/context/PartnerContext";

export const Footer = () => {
  const { config } = usePartner();

  return (
    <footer className="relative overflow-hidden bg-brand-ink text-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-12 pb-28 sm:pt-16 lg:pb-10">
        <div className="grid md:grid-cols-2 gap-10">
          <div>
            <img
              src="/brand/logo-white.png"
              alt="OperaSafe.cl — Protegemos todo lo que mueve tu operación industrial"
              className="h-14 sm:h-16 w-auto"
            />
            {config && (
              <div
                data-testid="footer-partner-cobrand"
                className="mt-5 flex items-center gap-3 rounded-2xl border border-white/15 bg-white/5 px-4 py-3 sm:w-fit"
              >
                <span className="text-[10px] font-medium uppercase leading-tight tracking-wider text-white/50">
                  en alianza<br />exclusiva con
                </span>
                <img
                  src={config.logoWhite || config.logo}
                  alt={config.name}
                  className="h-4 w-auto shrink-0 sm:h-5"
                />
              </div>
            )}

            <p className="mt-5 max-w-sm text-white/70">
              Seguros especializados para empresas industriales: maquinaria, equipos, plantas,
              ingeniería, flotas, transporte, responsabilidad civil, colaboradores y
              garantías (fiel cumplimiento, seriedad de la oferta, anticipos y correcta
              ejecución de las obras).
            </p>
          </div>
          <div className="md:text-right">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">Contacto</p>
            <a
              data-testid="footer-email"
              href={`mailto:${CONTACT_EMAIL}`}
              className="mt-3 inline-flex h-11 items-center gap-2 text-lg font-medium transition-colors hover:text-brand-yellow"
            >
              <Mail className="h-5 w-5" /> {CONTACT_EMAIL}
            </a>
            <div className="md:flex md:justify-end">
              <a
                data-testid="footer-phone"
                href={`tel:${CONTACT_PHONE_TEL}`}
                className="inline-flex h-11 items-center gap-2 text-lg font-medium transition-colors hover:text-brand-yellow"
              >
                <Phone className="h-5 w-5" /> {CONTACT_PHONE}
              </a>
            </div>
            <div className="mt-4">
              <a
                data-testid="footer-whatsapp"
                href={whatsappUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-brand-whatsapp px-5 py-2.5 font-semibold text-white transition-all hover:-translate-y-0.5 hover:shadow-lg"
              >
                <MessageCircle className="h-5 w-5" /> Escríbenos por WhatsApp
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 flex flex-col gap-3 text-[13px] sm:mt-14 sm:pt-8 sm:text-sm text-white/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p>© {new Date().getFullYear()} OperaSafe.cl · Corredora de seguros</p>
            <p>Respaldados por BCI Seguros · SURA · Zurich · Reale · HDI · MAPFRE · Renta Nacional</p>
          </div>
          <p className="text-center sm:text-left text-white/40">
            Corredora inscrita en el Registro de Corredores de Seguros de la Comisión para el
            Mercado Financiero (CMF), Chile. · Datos protegidos · Cotizar es gratis y sin compromiso.
          </p>
        </div>
      </div>
    </footer>
  );
};
